export class Address {
  strasse?: string;
  hausnummer?: string;
  plz?: string;
  ort?: string;
  mail?: string;
  phone?: string;
}
